import { withInstall as o } from "../../utils/with-install.js";
import t from "./option.vue.js";
/* empty css            */
const r = o(t);
export {
  r as ApOption
};
